import ruRU from 'antd/locale/ru_RU';
import uzUZ from 'antd/locale/uz_UZ';

export const langIds: Record<string, number> = {
  uz: 1,
  ru: 2,
  en: 3
};

export const antdLocales = {
  uz: uzUZ,
  ru: ruRU
};

export const colors = {
  black: '#000000',
  white: '#ffffff',
  primary: '#12B76A',
  green: {
    900: '#074D32',
    500: '#12B76A'
  },
  gray: {
    100: '#F3F4F6',
    400: '#9CA3AF'
  },
  blue: {},
  red: {},
  orange: {},
  yellow: {},
  teal: {},
  indigo: {},
  purple: {},
  pink: {}
};

export const queryKeys = {
  GET_THERE_DIRECTION: 'get-there-direction-data',
  GET_DIRECTION: 'get-direction-data',
  GET_FEEDBACK_ERROR_TYPE: 'get-feedback-errortype',
  GET_LANGUAGE: 'get-language-data',
  GET_UNIVERSITY_COURSE_SELECT: 'get-university-course-select',
  GET_UNIVERSITY_COURSE_SELECT_BY_SLUG: 'get-university-course-select-by-slug',
  GET_YEAR_DATA: 'get-year-data',
  GET_HEART_DATA: 'get-heart-data',
  GET_HEART_XP_DATA: 'get-heart-ball-data',
  GET_ALL_REGION: 'get-all-region',
  SUBJECTS_DATA: 'subjects-data',
  SUBJECTS_NAME: 'subjects-name',
  USER_DATA: 'userData',
  FAQ: 'faq'
};

export const pageNames = {
  CABINET: '/profile',
  CHECK_TEST: '/check',
  DTM: '/dtm',
  DTM_TEST: '/dtm/test',
  TOPIC_TEST: '/mavzuli-test',
  RESULTS: '/natijalar',
  OTM_LIST: '/otmlar-royhati',
  PRO: '/pro',
  PRO_PAYMENT: '/pro/payment',
  UNIVER_REC: '/univer-tavsiya',
  UNIVERSITIES: '/universitetlar',
  VIRTUAL: '/virtual',
  VIRTUAL_TEST: '/virtual/test',
  PRIVATE_UNIVERSITIES: '/xususiy-universitetlar',
  NEWS: '/yangiliklar',
  BLOCK_TEST: '/blok-test',
  LOGIN: '/login',
  SAVED_TEST: '/saqlangan-testlar',
  UNFINISHED: '/yakunlanmaganlar',
  NOT_FOUND: '/404',
  PRIVACY_POLICY: '/privacy',
  EXAM: '/exam',

  // ❌ Iltimos ketma ketligini o'zgartirmang! /pages dagi ketma ketlik bilan bir xil qilingan!
};

export const defaultLocation = {
  latitude: 41.2995,
  longitude: 69.2401

  // Tashkent
};

export const extraTranslation = {
  header: {
    uz: {
      bosh_sahifa: 'Bosh sahifa',
      mavzuli_test: 'Mavzuli test',
      blok_test: 'Blok test',
      oliygohlar: 'Oliygohlar',
      yangiliklar: 'Yangiliklar',
      xususiy_universitetlar: 'Xususiy universitetlar',
      platforma_test_rejimida_ishlamoqda: 'Platforma sinov rejimida ishlamoqda!',
      kirish: 'Kirish',
      avvalgi_talqinga_qaytish: 'Avvalgi talqinga qaytish',
      yangi: 'yangi'
    },
    ru: {
      bosh_sahifa: 'Главная страница',
      mavzuli_test: 'Тематический тест',
      blok_test: 'Блок тест',
      oliygohlar: 'Университеты',
      yangiliklar: 'Новости',
      xususiy_universitetlar: 'Частные университеты',
      platforma_test_rejimida_ishlamoqda: 'Платформа работает в тестовом режиме!',
      kirish: 'Войти',
      avvalgi_talqinga_qaytish: 'Вернуться к предыдущей версии',
      yangi: 'новый'
    }
  },
  heart_modal: {
    uz: {
      yurak_tugadi: 'Yurak tugadi',
      keyin_yurak_toladi: "Keyin yurak to'ladi",
      sotib_olish: 'Sotib olish',
      keyinroq: 'Keyinroq'
    },
    ru: {
      yurak_tugadi: 'Сердца закончились',
      keyin_yurak_toladi: 'Позже сердце пополнится',
      sotib_olish: 'Купить',
      keyinroq: 'Позже'
    }
  },
  footer: {
    uz: {
      pro_banner: {
        title: 'Akam bilan talaba bo‘ling',
        day: 'kun',
        subscribe_pro: "Pro ga obuna bo'lish"
      },
      footer_title: "Bizning platformamiz O'zbekiston bo'yicha abiturientlar uchun turli test ilovasidir",
      contact_us: "Biz bilan bog'lanish",
      social: 'Ijtimoiy tarmoqlarimiz',
      contact: 'Tel',
      address: 'Manzil'
    },
    ru: {
      pro_banner: {
        title: 'Станьте студентом с Akam',
        day: 'день',
        subscribe_pro: 'Подписаться на Pro'
      },
      footer_title: 'Наше приложение — это тестовое приложение для абитуриентов по всему Узбекистану',
      contact_us: 'Свяжитесь с нами',
      social: 'Социальные сети',
      contact: 'Tel',
      address: 'Адрес'
    }
  },
  home: {
    uz: {
      title: '📚 Akam.uz – Onlayn Testlar, DTM Tayyorlov va Bilim Sinovlari! 🚀',
      description:
        '🎯 DTM, mavzuli va avto testlar – barchasi bir joyda! 🏆 Bilimingizni sinab ko‘ring, natijalaringizni baholang va yangi marralarni zabt eting! ✅'
    },
    ru: {
      title: '📚 Akam.uz – Онлайн Тесты, Подготовка к DTM и Проверка Знаний! 🚀',
      description:
        '🎯 DTM, тематические и авто тесты – всё в одном месте! 🏆 Проверьте свои знания, оцените результаты и достигайте новых высот! ✅'
    }
  },
  error_page: {
    uz: {
      kechirasiz_nimadur_xato_ketdi: 'Kechirasiz, tizimda xatolik yuz berdi!',
      last_step_button: 'Asosiy sahifaga',
      adminga_xabar_berish: 'Adminga xabar berish'
    },
    ru: {
      kechirasiz_nimadur_xato_ketdi: 'Извините, произошла ошибка в системе!',
      last_step_button: 'На главную страницу',
      adminga_xabar_berish: 'Сообщить администратору'
    }
  }
};
